import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './__generated__/src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery$parameters';

export const RecommendationsInProjectListEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "projects-directory-templates-sidebar" */ './index'),
	),
	getPreloadProps: (extraProps: EntryPointRouteParams) => ({
		extraProps,
		queries: {
			templatesQueryRef: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId: extraProps.tenantContext.cloudId,
					isAnonymous: extraProps.tenantContext.isAnonymous,
					isAllowingEndUsersToAccessCustomTemplates: fg(
						'allow_end_users_to_access_custom_templates',
					),
				},
			},
		},
	}),
});
